<table>
  <tr>
    <td [hidden]="isCopy() || isSummary()">
      <button pButton
              icon="fa fa-plus"
              (click)="copyWorkEntry($event)">
      </button>
    </td>
    <td [hidden]="!isCopy() || isSummary()">
      <button pButton
              icon="fa fa-minus"
              (click)="removeWorkEntry($event)">
      </button>
    </td>
    <td [hidden]="isLocked() || isSummary()">
      <button pButton
              icon="fa fa-lock"
              (click)="lockWorkEntry($event)">
      </button>
    </td>
  </tr>
</table>
